import { FunctionComponent } from 'react';
import { Flex, Box } from '@rebass/emotion';

import { FormattedMessage } from 'react-intl';
import Icon from './icons';
import messages from './ProductUpgradeMessage.messages';

import { UpgradePath } from '../../hook/useUpgradePaths';

const QualifiesForVariantMessage: FunctionComponent<{
  matchingUpgrade: UpgradePath;
}> = ({ matchingUpgrade }) => {
  return (
    <Flex
      justifyContent="space-between"
      flexWrap="wrap"
      data-testid="upgrade-message-qualifies-for-variant"
    >
      <Box mr={2}>
        <Icon width={25} type="check-mark-green" />
      </Box>
      <Box flex={1}>
        <FormattedMessage
          {...messages.qualifiesForVariant}
          values={{
            baseProduct: matchingUpgrade.baseProduct.title,
          }}
        />
      </Box>
    </Flex>
  );
};

export default QualifiesForVariantMessage;
